import template from './user-email-list-dialog.html';

class UserEmailListDialogViewModel
{

	constructor (page)
	{
		this.page = page;
		this.title = ko.observable();
		this.name = ko.observable('');
		this.namespace = ko.observable('');

		this.templateList = ko.observableArray([]);
		this.templateName = ko.computed(() => { return this.templateList().filter((item) => { return item.name }) });
		this.selectedTemplateName = ko.observable();
		this.templateNamespace = ko.computed(() => { return this.templateList().filter((item) => { return item.namespace }) });
		this.selectedTemplateNamespace = ko.observable();

		this.list = ko.observableArray([]);
		this.emailList = ko.computed(() => { return this.list().filter((item) => { return item.name }) });
		this.selectedEmailList = ko.observable();

		this.channels = ko.observableArray([]);
		this.driverChannels = ko.computed(() => { return this.channels().filter((item) => { return item.driver=="Email" }) });
		this.selectedChannel = ko.observable();

	}

	async getTemplates ()
	{

		let params = {
			schema: 'messages',
			table: 'v_templates',
			filter: [
				{
					field: 'driver_name',
					operand: '=',
					value: 'Email'
				}
			]

		};

		let results = await Grape.fetches.getJSON("/api/record", params);

		if (results) {
			if (results.result_count == 0 || results.records == undefined)
				results.records = [];

			this.templateList(results.records);
		}

	}

	async get_user_email_list ()
	{
		let params = {
			schema: 'messages',
			table: 'v_address_list',
			sortfield: 'address_list_id',
			limit: 5000
		};

		let results = await Grape.fetches.getJSON("/api/record", params);

		if (results)
		{
			if (results.result_count == 0 || results.records == undefined)
				results.records = [];
				
			this.list(results.records);
		}
	}

	async btnSend()
	{

		this.list().filter(async (item) => {
			if (item.name == this.selectedEmailList()) {

				let response = await Grape.fetches.postJSON('/api/messages/template-sendout',
					{

						template_data: {
							event: {
								url: window.location.href,
								product_name: Grape.config.public_settings.product_name,
								report_name: this.page.bindings.initial_values.name,
								report_description: this.page.bindings.initial_values.description,
								row_count: this.page.bindings.initial_values.record_total,
								report_id: this.page.bindings.initial_values.report_id
							}
						},
						attachment: {},
						to_address_list_id: item.address_list_id,
						name: this.selectedTemplateName(),
						namespace: this.selectedTemplateNamespace(),
						channel: this.selectedChannel()

					}
				);

				if (response?.status !== 'OK')
					Grape.alerts.alert({ type: 'error', title: 'Error', message: JSON.stringify(response) });

				this.page.close(false);
			}
		});

	}

	btn_close_click ()
	{
		this.page.close(false);
	}

}

class UserEmailListDialog
{
	constructor (bindings, elements)
	{
		this.bindings = bindings;
		this.elements = elements;
		this.viewModel = new UserEmailListDialogViewModel(this);
		this.name = 'UserEmailListDialog';
	}

	async init ()
	{

		this.viewModel.title('Send To Email List');

	}

	async updateData ()
	{
		this.viewModel.get_user_email_list();
		this.viewModel.getTemplates();
		this.viewModel.channels(await Grape.cache.get('Channels'));
	}
	
}

export default {
	name: 'UserEmailListSend',
	dialog_class: UserEmailListDialog,
	template: template,
	provider: "ps"
};
